






























let vm!: any;
let AMap!: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import Breadcrumb from '../../components/Breadcrumb.vue';
import Info from './MapInfo.vue';
import { MarkViewModel, MarkService } from '../../api/mark';

@Component({
  components: {
    Breadcrumb,
    Info,
  },
})
export default class MapIndex extends Vue {
  private breadcrumbData = [{name: '媒资地图'}];
  private data: MarkViewModel[] = [];
  private service: MarkService = new MarkService();
  private amap!: any;
  private mapHeight: string = '500px';
  private markListHeight: string = '500px';
  private center: number[] = [117.751547, 39.130889];
  private infoPosition: number[] = this.center;
  private zoom: number = 14;
  private selectMark: MarkViewModel = this.service.NewModel;
  private selectIndex: number = -1;
  private showInfo: boolean = false;

  private markerEvents: any = {
    click(val: any) {
      vm.selectIndex = parseInt(val.target.getExtData());
      vm.selectMark = vm.data[vm.selectIndex];
      vm.showInfoWindow(val.lnglat);

      // const infoWindow = vm.$refs['info-window'] as any;
      // this.infoPosition = [val.lnglat.Q, val.lnglat.P];
      // const selectIndex = parseInt(val.target.getExtData());
      // vm.selectMark = vm.data[selectIndex];
      // infoWindow.$$getInstance().open(vm.amap, val.lnglat);
      // infoWindow.$$getInstance().setPosition( new AMap.LngLat(this.infoPosition[0], this.infoPosition[1]));
      // vm.$nextTick(() => {
      //   // vm.showInfo = true;
      //   vm.$set(vm, 'showInfo', true);
      // });
    },
  };

  private mapEvents: any = {
    init: (o: any) => {
      vm.amap = o;
      // this.moveMaker.setMap(o);
    },
  };

  private created() {
    vm = this;
    AMap = (window as any).AMap;
    this.mapHeight = (window.innerHeight - 70) + 'px';
    this.markListHeight = (window.innerHeight - 160) + 'px';
    this.service.GetHomeMark().then((response: any) => {
      this.data = response;
    });
  }

  private showInfoWindow(position: any) {
    console.log(position);
    const infoWindow = vm.$refs['info-window'] as any;
    infoWindow.$$getInstance().open(vm.amap, position);
  }

  private marker_OnClick(index: number) {
    this.selectIndex = index;
    this.selectMark = this.data[index];
    const position = (this.$refs[`marker${index}`] as any)[0].$$getInstance().getPosition();
    this.showInfoWindow(position);
    // console.log(this.$refs['marker' + index][0].events);
    // (this.$refs['marker' + index][0] as any).events.click();
  }
  private Mark_OnClick(markdata: any) {
    this.$router.replace({name: 'fileindex', query: {m: markdata.id}});
  }

}
